import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import {
  YodaBorderRadius,
  YodaColors,
  YodaFontSize,
  YodaFontWeight,
  YodaJustifyContent,
  YodaSpacing,
} from 'yoda-ui/yodaTheme';

export const targetListSelectStyle: SxProps<Theme> = {
  gap: YodaSpacing.small,

  '& .MuiFormControlLabel-root': {
    flex: 1,
    borderRadius: YodaBorderRadius.small,
    border: `1px ${YodaColors.textSecondary} solid`,
    paddingX: YodaSpacing.small,
    paddingY: YodaSpacing.xxxSmall,
    margin: 0,
    color: YodaColors.textSecondary,

    '&:hover': {
      borderColor: YodaColors.blue7,
      color: YodaColors.textPrimary,
    },

    '&.Mui-disabled': {
      borderColor: YodaColors.gray1,
    },

    '&:has(.Mui-checked)': {
      borderWidth: '2px',
      borderColor: YodaColors.blue7,
      color: YodaColors.textPrimary,
    },
  },

  '& .MuiRadio-colorPrimary.Mui-checked': {
    color: YodaColors.blue7,
  },

  '& .MuiFormControlLabel-label': {
    flex: 1,
    fontWeight: YodaFontWeight.medium,
    fontSize: YodaFontSize.small,
  },
};

export const TargetsListFooterStyle = (theme: Theme): SxProps<Theme> => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignContent: 'flex-start',
  flexWrap: 'wrap',

  [theme.breakpoints.up('xl')]: {
    flexWrap: 'nowrap',
  },
});

export const TargetsActionButtonsStyle = (theme: Theme): SxProps<Theme> => ({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  alignItems: 'flex-end',
  justifyContent: YodaJustifyContent.flexEnd,
  gap: YodaSpacing.small,

  [theme.breakpoints.down('xl')]: {
    margin: '0 0 0 auto',
  },

  '& .MuiBox-root': {
    display: 'flex',
    justifyContent: YodaJustifyContent.flexEnd,
    gap: YodaSpacing.small,
  },
});

export const targetListGridFilterStyle: SxProps<Theme> = {
  display: 'flex',
  gap: YodaSpacing.small,
  marginBottom: YodaSpacing.medium,
};

export const checkboxStyle: SxProps<Theme> = {

  '& .MuiSvgIcon-root': {
    color: `${YodaColors.textSecondary} !important`,
  },

  '&.Mui-checked .MuiSvgIcon-root': {
    color: `${YodaColors.blue7} !important`,
  },
};
